<template>
  <div>
    <h2 v-if="busy">loading...</h2>
    <!--<ChooseBox @success="setActive" @editView="editView" @editDone="editDone" @chosenBox="chosenBox"-->
               <!--v-bind:active="activeStep === 'ChooseBox'"></ChooseBox>-->
    <UserCreator @success="setActive" @editView="editView" @editDone="editDone" step="1"
                 v-bind:active="activeStep === 'UserCreator'"></UserCreator>
    <AddressCreator @success="setActive" @editView="editView" @editDone="editDone" step="2"
                    v-bind:active="activeStep === 'AddressCreator'"></AddressCreator>
    <PaymentMethodCreator @success="setActive" @editView="editView" @editDone="editDone" step="3"
                          v-bind:active="activeStep === 'PaymentMethodCreator'"></PaymentMethodCreator>
    <ReviewDirect @success="setActive" @editView="editView" @editDone="editDone" step="4"
                          v-bind:active="activeStep === 'ReviewDirect'"></ReviewDirect>
  </div>
</template>

<script>
  import user from '../lib/user';
//  import ChooseBox from './chooseBox/ChooseBox';
  import UserCreator from './account/UserCreatorDirect';
  import PaymentMethodCreator from './payment/PaymentMethodCreator';
  import AddressCreator from './address/AddressCreator';
  import ReviewDirect from './review/ReviewDirect';
  import store from '../lib/store';

//      ChooseBox,
  export default {
    name: 'StepsDirect',
    components: {
      UserCreator,
      PaymentMethodCreator,
      AddressCreator,
      ReviewDirect,
    },
    data() {
      return {
        busy: false,
        activeStep: 'UserCreator',
        incompleteStep: 'UserCreator',
        box: null,
      };
    },
    methods: {
      setActive() {
        if (this.activeStep !== this.incompleteStep) {
          this.activeStep = this.incompleteStep;
          return;
        }
        let res;
        switch (this.activeStep) {
          case 'ChooseBox':
            res = 'UserCreator';
            break;
          case 'UserCreator':
            res = 'AddressCreator';
            break;
          case 'AddressCreator':
            res = 'PaymentMethodCreator';
            break;
          case 'PaymentMethodCreator':
            res = 'ReviewDirect';
            break;
          case 'ReviewDirect':
            this.createLog();
            break;
          default:
          // do nothing
        }
        this.activeStep = res;
        this.incompleteStep = res;
      },
      editView(view) {
        this.activeStep = view;
      },
      editDone() {
        this.activeStep = this.incompleteStep;
      },
      chosenBox(box) {
        this.box = box;
      },
      createLog() {
        user.create_club_membership({ short_name: store.get('brewery') }, (err, res) => {
          if (err) {
            this.parseErrors(res);
            // user.create_log({ name, box }, (err2, res2) => {
            //   if (err2) {
            //     this.parseErrors(res2);
            //   } else {
            //     this.$emit('success');
            //   }
            // });
          } else {
            this.$emit('success');
          }
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// StepsDirect.vue?39ac255c